(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CoutAchatEauDetailController', CoutAchatEauDetailController);

    CoutAchatEauDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CoutAchatEau'];

    function CoutAchatEauDetailController($scope, $rootScope, $stateParams, entity, CoutAchatEau) {
        var vm = this;
        vm.coutAchatEau = entity;
        vm.load = function (id) {
            CoutAchatEau.get({id: id}, function(result) {
                vm.coutAchatEau = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:coutAchatEauUpdate', function(event, result) {
            vm.coutAchatEau = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
